import "../css/about.css";
import {
  FaWineBottle,
  FaTruck,
  FaShieldAlt,
  FaHeadset,
  FaAward,
  FaUsers,
  FaShoppingBag,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="about-page">

      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <h1>About SIP LIQUORS</h1>

          <p>
            Premium wines, whiskey, beer, tequila, vodka, champagne,
            and fine spirits delivered with quality, convenience,
            and exceptional customer service.
          </p>

          <Link to="/shop" className="about-btn">
            Shop Now
          </Link>
        </div>
      </section>

      {/* Our Story */}

      <section className="about-section">
        <div className="container">

          <h2>Our Story</h2>

          <p>
            SIP LIQUORS was founded with a simple mission:
            provide customers with an easy, secure,
            and enjoyable online liquor shopping experience.
            From premium whiskey to refreshing wines and beers,
            we carefully select every product to ensure
            outstanding quality and authenticity.
          </p>

        </div>
      </section>

      {/* Statistics */}

      <section className="about-stats">

        <div className="container">

          <div className="stats-grid">

            <div className="stat-box">
              <h2>5000+</h2>
              <p>Happy Customers</p>
            </div>

            <div className="stat-box">
              <h2>1000+</h2>
              <p>Premium Products</p>
            </div>

            <div className="stat-box">
              <h2>50+</h2>
              <p>Top Brands</p>
            </div>

            <div className="stat-box">
              <h2>99%</h2>
              <p>Customer Satisfaction</p>
            </div>

          </div>

        </div>

      </section>

      {/* Why Choose Us */}

      <section className="about-section">

        <div className="container">

          <h2>Why Choose SIP LIQUORS?</h2>

          <div className="about-grid">

            <div className="about-card">
              <FaWineBottle className="about-icon" />
              <h3>Premium Collection</h3>
              <p>
                Discover premium wines, whiskey, tequila,
                vodka, beer, champagne, and exclusive spirits.
              </p>
            </div>

            <div className="about-card">
              <FaShieldAlt className="about-icon" />
              <h3>Secure Payments</h3>
              <p>
                Shop confidently using trusted and secure
                payment gateways.
              </p>
            </div>

            <div className="about-card">
              <FaTruck className="about-icon" />
              <h3>Fast Delivery</h3>
              <p>
                Quick order processing with reliable
                doorstep delivery.
              </p>
            </div>

            <div className="about-card">
              <FaHeadset className="about-icon" />
              <h3>24/7 Support</h3>
              <p>
                Our support team is always available
                to assist with your orders.
              </p>
            </div>

            <div className="about-card">
              <FaAward className="about-icon" />
              <h3>Trusted Quality</h3>
              <p>
                Every bottle is sourced from
                trusted suppliers and brands.
              </p>
            </div>

            <div className="about-card">
              <FaUsers className="about-icon" />
              <h3>Thousands of Customers</h3>
              <p>
                Join thousands of satisfied customers
                shopping with SIP LIQUORS.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* Mission */}

      <section className="about-section gray">

        <div className="container">

          <h2>Our Mission</h2>

          <p>
            Our mission is to make premium liquor shopping
            easy, secure, and accessible while delivering
            excellent customer service and the finest products.
          </p>

        </div>

      </section>

      {/* Bottom CTA */}

      <section className="about-bottom">

        <div className="container">

          <FaShoppingBag className="bottom-icon" />

          <h2>Experience Premium Liquor Shopping</h2>

          <p>
            Browse our carefully curated collection
            and enjoy fast delivery, secure payments,
            and premium customer support.
          </p>

          <Link to="/shop" className="about-btn">
            Start Shopping
          </Link>

        </div>

      </section>

    </div>
  );
}

export default About;